import './styles/maintenance-template-item.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import DeleteMaintenanceTemplateButton from './DeleteMaintenanceTemplateButton'
import NewMaintenanceTemplateButton    from './NewMaintenanceTemplateButton'

export default class MaintenanceTemplateItem extends React.Component {
  static propTypes = {
    item:    PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  render() {
    const { item, history } = this.props

    return (
      <div className="maintenance-template-item">
        <div className="header">
          <div className="name">{ item.name }</div>
          { item.description && <div className="description">{ `(${item.description})` }</div> }
        </div>

        <div className="actions">
          <div className="action-container">
            <NewMaintenanceTemplateButton maintenanceTemplate={item} history={history} />
            <DeleteMaintenanceTemplateButton maintenanceTemplate={item} />
          </div>
        </div>
      </div>
    )
  }
}